// src/components/Footer.js
import React from "react";
import { Link } from "react-router-dom";
import { BRAND, NAV_LINKS, SEO } from "../utils/constants";
import "./Footer.css";

const EMAIL_CHANNELS = [
  { label: "General",   email: BRAND.email.general },
  { label: "Sales",     email: BRAND.email.sales },
  { label: "Technical", email: BRAND.email.technical },
  { label: "Marketing", email: BRAND.email.marketing },
];

export default function Footer() {
  return (
    <footer className="footer" role="contentinfo">
      <div className="footer__top container">

        {/* Brand */}
        <div className="footer__brand">
          <img
            src="/assets/logo.png"
            alt="Sunaharco"
            className="footer__logo"
            onError={(e) => { e.target.style.display = "none"; }}
          />
          <p className="footer__desc">
            Sunaharco delivers trusted solutions across three core areas: sustainable agriculture, premium ceramic mugs, and HVAC comfort systems. We combine quality, craftsmanship, and innovation for farms, homes, and commercial spaces.
          </p>
          <p className="footer__tagline">🌿 {BRAND.taglineAlt}</p>
        </div>

        {/* Quick Links */}
        <div className="footer__col">
          <h4 className="footer__heading">Quick Links</h4>
          <ul className="footer__list">
            {NAV_LINKS.map((l) => (
              <li key={l.to}>
                <Link to={l.to} className="footer__link">{l.label}</Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Contact */}
        <div className="footer__col">
          <h4 className="footer__heading">Get in Touch</h4>
          <ul className="footer__list">
            {EMAIL_CHANNELS.map((e) => (
              <li key={e.email}>
                <span className="footer__label">{e.label}</span>
                <a href={`mailto:${e.email}`} className="footer__link footer__email">
                  {e.email}
                </a>
              </li>
            ))}
          </ul>
          {BRAND.whatsappNumber !== "918679085556" && (
            <a
              href={`https://wa.me/${BRAND.whatsappNumber}`}
              className="footer__wa-btn"
              target="_blank"
              rel="noreferrer"
            >
              💬 WhatsApp Us
            </a>
          )}
        </div>

        {/* Keywords */}
        <div className="footer__col">
          <h4 className="footer__heading">Our Focus</h4>
          <div className="footer__tags">
            {SEO.keywords.slice(0, 6).map((tag) => (
              <span key={tag} className="footer__tag">{tag}</span>
            ))}
          </div>
        </div>
      </div>

      <div className="footer__bottom container">
        <p className="footer__copy">
          © {new Date().getFullYear()} {BRAND.name}. All rights reserved. {BRAND.tagline}.
        </p>
        <Link to="/admin" className="footer__admin-link">Admin</Link>
      </div>
    </footer>
  );
}
